import intersect from "path-intersection";
/**
 * conllision test
 *
 * @param {string} pathDataStr
 * @param {{ x0_pu: number, y0_pu: number, x1_pu: number, y1_pu: number }} line
 * @memberof InkStorage
 */
export const collisionTest = (pathDataStr, line) => {
    const eraserSvgPathData = 'M ' +
        line.x0_pu + ' ' + line.y0_pu +
        ' L ' + line.x1_pu + ' ' + line.y1_pu +
        'z';
    const intersection = intersect(eraserSvgPathData, pathDataStr);
    return (intersection === null || intersection === void 0 ? void 0 : intersection.length) > 0;
};
export const collisionTest_arr = (pathDataStr, line) => {
    let eraserSvgPathData = "";
    const len = line.length;
    for (let i = 0; i < len; i++) {
        eraserSvgPathData +=
            (i === 0 ? 'M ' : 'L ') +
                line[i].x + ' ' + line[i].y +
                (i === len - 1 ? 'z' : ' ');
    }
    const intersection = intersect(eraserSvgPathData, pathDataStr);
    return (intersection === null || intersection === void 0 ? void 0 : intersection.length) > 0;
};
export const makeSvgPath = (line) => {
    let pathStr = "";
    const len = line.length;
    for (let i = 0; i < len; i++) {
        pathStr +=
            (i === 0 ? 'M ' : 'L ') +
                line[i].x + ' ' + line[i].y +
                (i === len - 1 ? 'z' : ' ');
    }
    return pathStr;
};
//# sourceMappingURL=renderer_utils.js.map